<div *ngIf="selectedFAQ">
    <h3 class="titulo-faqs" >{{ selectedFAQ.fieldName }}</h3>
    <ul class="lista-faqs">
      <li *ngFor="let faq of selectedFAQ.faqs" >
        <strong class="pergunta-faqs">{{ faq.question }}</strong>
        <p class="resposta-faqs"><strong>{{ faq.answer }}</strong></p>
      </li>
    </ul>
  </div>  
